<template>
  <v-navigation-drawer
    v-model="drawer"
    :temporary="$vuetify.display.mobile"
    :permanent="!$vuetify.display.mobile"
    color="#343F53"
    class="sidebar"
  >
    <div class="d-flex flex-column fill-height justify-space-between">
      <!-- TOPO: logo e menu -->
      <div>
        <!-- Logo Header -->
        <v-list-item
          class="header-user py-4 px-4"
          @click="$router.push('/admin/despedidas')"
        >
          <div style="text-align: center; padding: 20px 0; cursor: pointer">
            <img
              @click="$router.push('/modulos')"
              src="../../assets/images/logos/LogoGrupoParqueBranca.png"
              width="40%"
            />
          </div>
        </v-list-item>

        <v-divider class="border-opacity-25"></v-divider>

        <!-- Menu Items -->
        <v-list density="compact" nav color="transparent">
          <v-list-item
            v-for="item in itensPermitidos"
            :key="item.title"
            :prepend-icon="item.icon"
            :title="item.title"
            :value="item.rota"
            :active="isRouteActive(item.rota)"
            :to="item.rota"
            class="menu-item mb-2"
            rounded="lg"
            color="white"
          >
            <template v-slot:prepend>
              <v-icon
                :color="isRouteActive(item.rota) ? 'white' : 'grey-lighten-2'"
              >
                {{ item.icon }}
              </v-icon>
            </template>
          </v-list-item>
        </v-list>
      </div>

      <!-- BASE: Alterar senha + Perfil -->
      <div>
        <v-list nav class="pb-0" v-if="profileUser">
          <v-list-item
            rounded="lg"
            color="white"
            title="Alterar senha"
            class="menu-item"
            @click="$router.push('/admin/alterar-senha')"
          >
            <template v-slot:prepend>
              <v-icon
                :color="
                  isRouteActive('/admin/alterar-senha')
                    ? 'white'
                    : 'grey-lighten-2'
                "
              >
                mdi-key-chain
              </v-icon>
            </template>
          </v-list-item>
        </v-list>
        <v-list nav class="pb-2">
          <v-list-item
            rounded="lg"
            color="white"
            title="Sair"
            class="menu-item"
            @click="logout()"
          >
            <template v-slot:prepend>
              <v-icon :color="isRouteActive('/') ? 'white' : 'grey-lighten-2'">
                mdi-logout
              </v-icon>
            </template>
          </v-list-item>
        </v-list>

        <!-- User Profile -->
        <v-card
          class="user-profile pa-4 mx-4 my-2"
          elevation="0"
          color="transparent"
          v-if="profileUser"
          @click="$router.push('/admin/editar-perfil/0')"
        >
          <div class="d-flex align-center">
            <v-avatar color="grey-lighten-2" size="30">
              <v-icon color="white" size="24">mdi-account</v-icon>
            </v-avatar>
            <div class="ml-3">
              <div
                class="text-body-2 text-white font-weight-medium text-truncate"
              >
                {{ profile.nome }}
              </div>
              <div
                class="text-caption text-grey-lighten-1 text-truncate"
                style="max-width: 140px"
              >
                {{ profile.email }}
              </div>
            </div>
            <v-spacer></v-spacer>
          </div>
        </v-card>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  data() {
    return {
      currentRoute: this.$route.path,
      nome: {},
      menuItems: [
        {
          title: "Despedidas",
          icon: "mdi-book-cross",
          rota: "/admin/despedidas",
          roles: ["ROLE_ADMIN", "ROLE_COLABORADOR"],
        },
        {
          title: "Painel de Capelas",
          icon: "mdi-church",
          rota: "/admin/painel-despedidas",
          roles: ["ROLE_ADMIN", "ROLE_COLABORADOR"],
        },
        {
          title: "Aprovar Mensagens",
          icon: "mdi-checkbox-marked",
          rota: "/admin/painel-mensagens",
          roles: ["ROLE_ADMIN", "ROLE_COLABORADOR"],
          children: [
            {
              title: "Aprovar Mensagens",
              icon: "mdi-book-open",
              rota: "/admin/painel-mensagens",
              roles: ["ROLE_ADMIN", "ROLE_COLABORADOR"],
            },
          ],
        },
        {
          title: "Colaboradores",
          icon: "mdi-account-group",
          rota: "/admin/cadastro-colaborador",
          roles: ["ROLE_ADMIN"],
        },
      ],
      profileUser: false,
      profile: {
        id: 0,
        nome: "",
        email: "",
      },
      roles: [],
    };
  },
  mounted() {
    this.consultarPerfil();
    this.setRolesFromSession();
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(value) {
        this.$store.state.drawer = value;
      },
    },
    itensPermitidos() {
      return this.menuItems.filter((item) => this.temPermissao(item.roles));
    },
  },

  methods: {
    setRolesFromSession() {
      const user = JSON.parse(sessionStorage.getItem("user"));
      this.roles = user?.roles || [];
    },
    consultarPerfil() {
      http
        .get("cliente/perfil", {
          headers: authHeader(),
        })
        .then((response) => {
          this.profile = response.data.pessoa;
          this.profile.email = response.data.email;
          this.profileUser = true;
        })
        .catch((error) => {
          console.error("Erro ao carregar perfil:", error);
        });
    },
    isRouteActive(route) {
      return this.$route.path === route;
    },
    temPermissao(rolesNecessarias) {
      // Se não houver roles necessárias, permite acesso
      if (!rolesNecessarias || rolesNecessarias.length === 0) {
        return true;
      }

      // Verifica se o usuário possui pelo menos uma das roles necessárias
      return this.roles.some((role) => rolesNecessarias.includes(role));
    },
    logout() {
      sessionStorage.removeItem("user");
      this.$router.push("/");
      toast.success("Logout realizado com sucesso!");
    },
  },
  watch: {
    $route(to) {
      this.currentRoute = to.path;
    },
  },
};
</script>

<style scoped>
.sidebar {
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}

.header-user {
  cursor: pointer;
  padding: 0 !important;
}

.menu-item {
  margin: 0 12px;
  transition: all 0.3s ease;
  font-size: 0.8rem;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.menu-item.v-list-item--active {
  background: rgba(255, 255, 255, 0.15);
  font-weight: bold;
}

.menu-item.v-list-item--active .v-list-item-title {
  color: white;
}

.menu-item:not(.v-list-item--active) .v-list-item-title {
  color: rgba(255, 255, 255, 0.8);
}

.header-user {
  background-color: #343f53;
  min-height: 8vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.menu-item :deep(.v-list-item-title) {
  font-size: 1rem;
  font-weight: 400;
}
.user-profile {
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  cursor: pointer;
}
</style>
